//const { VuetifyLoaderPlugin } = require("vuetify-loader");

module.exports = {
  /*
  configureWebpack: {
    plugins: [new VuetifyLoaderPlugin({ autoImport: true })],
  },
  */
  css: {
    loaderOptions: {
      scss: {
        additionalData: "@import '@/src/scss/variables.scss'",
      },
    },
  },
  publicPath: '/',
  chainWebpack: (config) => {
    config.plugin('html').tap((args) => {
      args[0].title = 'Database Multimediale Infinito #DMI';
      return args;
    });
  },
};
